import require$$0, { createContext, useContext, useState, useCallback, useMemo, Suspense, useEffect } from "react";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React = require$$0;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step2;
                while (!(step2 = iterator.next()).done) {
                  if (isValidElement(step2.value)) {
                    validateExplicitKey(step2.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = require$$0, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a)
      m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps)
      for (b in a = c.defaultProps, a)
        void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
let generatedStepIndex = 0;
let trunkIndex = 0;
const TRUNK_PREFIX = "trunk-";
function buildSteps(items) {
  const stepsWithTrunks = group(items);
  const stepMap = /* @__PURE__ */ new Map();
  const stepsWithoutTrunks = [];
  const foundTrunks = [];
  function gatherMetadata() {
    for (const stepWithTrunk of stepsWithTrunks) {
      stepMap.set(stepWithTrunk.name, stepWithTrunk);
      if (stepWithTrunk.name.startsWith(TRUNK_PREFIX)) {
        foundTrunks.push(stepWithTrunk.name);
      } else {
        stepsWithoutTrunks.push(stepWithTrunk);
      }
    }
  }
  function removeTrunksFromDefinition() {
    for (const stepWithTrunk of stepsWithTrunks) {
      stepWithTrunk.next = detrunk(stepWithTrunk.next, stepMap);
    }
    for (const foundTrunk of foundTrunks) {
      stepMap.delete(foundTrunk);
    }
  }
  function connectBackwards() {
    for (const stepsWithoutTrunk of stepsWithoutTrunks) {
      const next = stepsWithoutTrunk.next;
      if (typeof next === "string") {
        const nextItem = stepMap.get(next);
        if (!nextItem) {
          throw new Error(
            `Could not find next item with name ${next} while connecting previous step, at ${stepsWithoutTrunk.name}`
          );
        }
        if (!nextItem.previous) {
          nextItem.previous = stepsWithoutTrunk.name;
        }
      }
      if (Array.isArray(next)) {
        for (const path of next) {
          const nextItem = stepMap.get(path.target);
          if (!nextItem) {
            throw new Error(
              `Could not find next item with name ${path.target} while connecting previous steps, at ${stepsWithoutTrunk.name}`
            );
          }
          if (!nextItem.previous) {
            nextItem.previous = [
              {
                target: stepsWithoutTrunk.name,
                enabled: typeof stepsWithoutTrunk.enabled === "undefined" ? true : stepsWithoutTrunk.enabled
              }
            ];
          } else if (Array.isArray(nextItem.previous)) {
            nextItem.previous.push({
              target: stepsWithoutTrunk.name,
              enabled: typeof stepsWithoutTrunk.enabled === "undefined" ? true : stepsWithoutTrunk.enabled
            });
          } else {
            throw new Error(
              `Tried connecting "previous" property of step ${nextItem.name} to step ${stepsWithoutTrunk.name},

                 but it already had the key defined as string.
 This would introduce ambiguity, define 

                 the "previous" key on step "${nextItem.name}" manually in the definition.`
            );
          }
        }
      }
    }
  }
  gatherMetadata();
  removeTrunksFromDefinition();
  connectBackwards();
  generatedStepIndex = 0;
  trunkIndex = 0;
  return {
    list: stepsWithoutTrunks,
    record: stepMap
  };
}
function group(items, options = {}) {
  if (isBranch(items.at(0))) {
    items = [trunk(), ...items];
  }
  if (options.name) {
    for (const item of items) {
      item.tags.push(options.name);
    }
  }
  let flattenedSteps = [];
  items.forEach((groupItem, index) => {
    if (isBranch(groupItem)) {
      const branchItemsWithMergedOptions = groupItem.items.map((child) => {
        return {
          ...child,
          tags: [...groupItem.tags, ...child.tags]
        };
      });
      flattenedSteps = [...flattenedSteps, ...branchItemsWithMergedOptions];
      return;
    }
    const nextItem = items.at(index + 1);
    flattenedSteps.push(groupItem);
    if (groupItem.next || !nextItem) {
      return;
    }
    if (nextItem && isBranch(nextItem)) {
      groupItem.next = nextItem.paths;
      return;
    }
    groupItem.next = nextItem.name;
  });
  if (options.enabled) {
    flattenedSteps.forEach((flattenedStep) => {
      flattenedStep.enabled = mergePredicates(
        flattenedStep.enabled,
        options.enabled
      );
    });
  }
  return flattenedSteps;
}
function split(branches) {
  const paths = [];
  let items = [];
  for (const branchEntry of branches) {
    const branchSteps = group(branchEntry.items, {
      enabled: branchEntry.enabled
    });
    const firstStep = branchSteps.at(0);
    if (!firstStep) {
      continue;
    }
    items = [...items, ...branchSteps];
    paths.push({
      target: firstStep.name,
      enabled: branchEntry.enabled
    });
  }
  return {
    items,
    paths,
    tags: []
  };
}
function branch(items, enabled) {
  return {
    items: Array.isArray(items) ? items : [items],
    enabled
  };
}
function step({
  name,
  ...restOptions
}) {
  return {
    name: name || `step-${generatedStepIndex++}`,
    ...restOptions,
    tags: []
  };
}
function stepTemplate({ name, ...restOptions }) {
  let localStepIndex = -1;
  return ({
    name: nameOverride,
    ...options
  } = {}) => {
    const generatedName = localStepIndex >= 0 ? `${name}-${localStepIndex}` : name;
    const definition = {
      name: nameOverride || generatedName || `step-${generatedStepIndex++}`,
      ...restOptions,
      ...options,
      tags: []
    };
    localStepIndex++;
    return definition;
  };
}
function detrunk(next, items) {
  if (typeof next === "string") {
    if (next.startsWith(TRUNK_PREFIX)) {
      const trunkItem = items.get(next);
      if (!trunkItem) {
        throw new Error(`Could not find trunk with name ${next}`);
      }
      return detrunk(trunkItem.next, items);
    }
    return next;
  }
  if (Array.isArray(next)) {
    const cleanPaths = [];
    for (const path of next) {
      if (!path.target.startsWith(TRUNK_PREFIX)) {
        cleanPaths.push(path);
      } else {
        const pathTarget = items.get(path.target);
        if (!pathTarget) {
          throw new Error(`Could not find target with name ${path.target}`);
        }
        const pathNextKey = detrunk(pathTarget.next, items);
        if (typeof pathNextKey === "string") {
          cleanPaths.push({
            target: pathNextKey,
            enabled: path.enabled
          });
        }
        if (Array.isArray(pathNextKey)) {
          for (const nestedPath of pathNextKey) {
            const enabled = mergePredicates(path.enabled, nestedPath.enabled);
            if (typeof enabled !== "undefined") {
              cleanPaths.push({
                target: nestedPath.target,
                enabled
              });
            }
          }
        }
      }
    }
    return cleanPaths;
  }
}
function mergePredicates(left, right) {
  if (typeof left === "undefined") {
    return right;
  }
  if (typeof right === "undefined") {
    return left;
  }
  return (context) => (typeof left === "boolean" ? left : left(context)) && (typeof right === "boolean" ? right : right(context));
}
function trunk() {
  return step({
    name: `${TRUNK_PREFIX}${trunkIndex++}`,
    Component: () => null
  });
}
function isBranch(item) {
  return Boolean(item) && typeof item !== "undefined" && "paths" in item;
}
class Funnel {
  constructor(definition) {
    __publicField(this, "stepHistory", []);
    __publicField(this, "currentStep", null);
    this.definition = definition;
  }
  detectBrowserStep() {
    const step2 = this.peekBrowserStep();
    if (!step2) {
      throw new Error("The current URL does not match any step in the funnel");
    }
    if (!this.checkPredicate(step2.enabled)) {
      const nextStep = this.calculateNextStep(step2, "backward");
      if (nextStep) {
        this.loadStep({
          step: nextStep,
          event: { changedFromDisabledStep: true }
        });
      } else {
        throw new Error(
          `Detected step ${step2.name} is not enabled, and there is no previous step to go back to`
        );
      }
    } else {
      this.loadStep({ step: step2 });
    }
  }
  peekBrowserStep() {
    var _a, _b;
    const location = (_b = (_a = this.definition).resolveLocation) == null ? void 0 : _b.call(_a);
    if (!location) {
      throw new Error(
        "Cannot detect browser step, because the location resolver is not defined, make sure your funnel definition has a `resolveLocation` function"
      );
    }
    for (const step2 of this.definition.steps.list) {
      const stepPath = `${this.definition.basePath || ""}${step2.uri || ""}`;
      const stepLocation = pathToURL(stepPath);
      const stepMatchesPath = this.trimTrailingSlashes(stepLocation.pathname) === this.trimTrailingSlashes(location.pathname);
      const stepMatchesSearch = isSearchSubsetOf(
        stepLocation.search,
        location.search
      );
      if (stepMatchesPath && stepMatchesSearch) {
        return step2;
      }
    }
  }
  trimTrailingSlashes(path) {
    return path.replace(/\/+$/, "");
  }
  stepForward() {
    const target = this.peekNextStep();
    if (target) {
      this.loadStep({ step: target });
    }
  }
  peekNextStep() {
    return this.currentStep ? this.calculateNextStep(this.currentStep) : null;
  }
  stepBack() {
    const previousStep = this.peekPreviousStep();
    if (!previousStep) {
      return;
    }
    this.loadStep({
      step: previousStep,
      options: { historyAction: "POP" }
    });
  }
  peekPreviousStep() {
    if (!this.currentStep) {
      return null;
    }
    const previousStep = this.calculateNextStep(this.currentStep, "backward");
    if (!previousStep) {
      return null;
    }
    if (!this.checkPredicate(previousStep.enabled)) {
      return this.calculateNextStep(previousStep, "backward");
    }
    return previousStep;
  }
  forceStep(name) {
    const step2 = this.getStep(name);
    if (!this.checkPredicate(step2.enabled)) {
      throw new Error(
        `Cannot force a step ${step2.name} that is currently not enabled`
      );
    }
    this.loadStep({ step: step2 });
  }
  loadStep({
    step: step2,
    options = { historyAction: "PUSH" },
    event
  }) {
    this.currentStep && options.historyAction === "PUSH" && this.stepHistory.push(this.currentStep);
    options.historyAction === "POP" && this.stepHistory.pop();
    this.currentStep = step2;
    if (this.definition.onStepChange) {
      this.definition.onStepChange(step2, {
        changedFromDisabledStep: false,
        ...event
      });
    }
  }
  /**
   * Takes a step and based on the direction, it will traverse the definition
   * and find a first enabled step to go to. If the direct previous step is
   * disabled, it will try to find a first enabled step in definition, and if
   * it fails, it will try to fall back to the step history. In case it fails
   * even then, user can handle the `null` return manually.
   */
  calculateNextStep(currentStep, direction = "forward") {
    const target = direction === "forward" ? currentStep.next : currentStep.previous;
    if (!target) {
      return null;
    }
    if (typeof target === "string") {
      const step2 = this.getStep(target);
      if (typeof step2.enabled !== "undefined" && !this.checkPredicate(step2.enabled)) {
        return this.calculateNextStep(step2, direction);
      }
      return step2;
    }
    for (const path of target) {
      if (this.checkPredicate(path.enabled)) {
        const step2 = this.getStep(path.target);
        if (typeof step2.enabled !== "undefined" && !this.checkPredicate(step2.enabled)) {
          return this.calculateNextStep(step2, direction);
        }
        return step2;
      }
    }
    if (target.length === 1 && direction === "backward") {
      const step2 = this.getStep(target[0].target);
      return this.calculateNextStep(step2, direction);
    }
    if (target.length > 0 && direction === "backward") {
      for (const step2 of this.stepHistory.reverse()) {
        if (this.checkPredicate(step2.enabled)) {
          return step2;
        }
      }
    }
    return null;
  }
  getStep(name) {
    const step2 = this.definition.steps.record.get(name);
    if (!step2) {
      throw new Error(`Step "${name}" not found in the funnel definition`);
    }
    return step2;
  }
  checkPredicate(predicate) {
    if (typeof predicate === "undefined") {
      return true;
    }
    if (typeof predicate === "boolean") {
      return predicate;
    }
    return predicate(this.context());
  }
  /**
   * Returns a step definition by its name together with some
   * debugging information. A helper function for testing.
   */
  peekStep(name) {
    const step2 = this.getStep(name);
    return {
      definition: step2,
      enabled: this.checkPredicate(step2.enabled)
    };
  }
  /**
   * Uses snapshot function to gather metadata about the funnel, then print JSON object.
   */
  dump() {
    console.log(JSON.stringify(this.snapshot(), null, 2));
  }
  /**
   * Uses snapshot function to gather metadata about the funnel, then logs the data.
   */
  debug() {
    console.log(this.snapshot());
  }
  /**
   * Gathers complete state of the funnel, useful for debugging.
   */
  snapshot() {
    var _a, _b, _c, _d;
    return {
      state: ((_b = (_a = this.definition).getState) == null ? void 0 : _b.call(_a)) ?? {},
      currentStep: this.currentStep,
      location: (_d = (_c = this.definition).resolveLocation) == null ? void 0 : _d.call(_c),
      stepHistory: this.stepHistory,
      definition: this.definition,
      stepList: this.definition.steps.list,
      stepRecord: this.definition.steps.record
    };
  }
  /**
   * Gathers metadata about the funnel, it passed to the funnel predicates.
   */
  context() {
    var _a, _b, _c, _d;
    return {
      state: ((_b = (_a = this.definition).getState) == null ? void 0 : _b.call(_a)) ?? {},
      currentStep: this.currentStep,
      location: (_d = (_c = this.definition).resolveLocation) == null ? void 0 : _d.call(_c),
      stepHistory: this.stepHistory
    };
  }
}
function pathToURL(path) {
  let finalPath = path;
  if (!path.startsWith("/")) {
    finalPath = `/${path}`;
  }
  return new URL(finalPath, "https://__internal_do_no_use_domain__.com");
}
function isSearchSubsetOf(subsetSearch, search) {
  const subsetParams = new URLSearchParams(subsetSearch);
  const searchParams = new URLSearchParams(search);
  for (const [key, value] of subsetParams.entries()) {
    if (searchParams.get(key) !== value) {
      return false;
    }
  }
  return true;
}
const FunnelContext = createContext(null);
function FunnelContextProvider({
  funnel,
  children
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FunnelContext.Provider, { value: funnel, children });
}
function useFunnel() {
  const funnel = useContext(FunnelContext);
  if (!funnel) {
    throw new Error(
      "You should call useFunnel inside FunnelContextProvider with a valid funnel provided"
    );
  }
  return funnel;
}
function StaticFunnel({ children }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FunnelContextProvider,
    {
      funnel: new Funnel({
        steps: { list: [], record: /* @__PURE__ */ new Map() }
      }),
      children
    }
  );
}
function ReactFunnel({
  definition,
  firstStep,
  loadingIndicator
}) {
  const [activeStep, setActiveStep] = useState(null);
  const onStepChange = useCallback(
    (step2) => {
      (activeStep == null ? void 0 : activeStep.name) !== (step2 == null ? void 0 : step2.name) && setActiveStep(step2);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we don't want this to recompute with activeStep changes, because later the funnel memo would recompute, it should stay the same
    [definition, setActiveStep]
  );
  const funnel = useMemo(
    () => buildFunnel({ definition: { ...definition, onStepChange }, firstStep }),
    [definition, firstStep, onStepChange]
  );
  if (!activeStep) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: loadingIndicator, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FunnelContextProvider, { funnel, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    ReactFunnelStep,
    {
      onStepEnter: definition.onStepEnter,
      step: activeStep
    }
  ) }) });
}
function buildFunnel({
  definition,
  firstStep
}) {
  const funnel = new Funnel(definition);
  if (firstStep) {
    funnel.forceStep(firstStep);
  } else {
    const initialStep = definition.steps.list.at(0);
    if (!initialStep) {
      throw new Error(
        "Funnel load error, funnel definition should always have at least one step"
      );
    }
    funnel.forceStep(initialStep.name);
  }
  return funnel;
}
function ReactFunnelStep({
  onStepEnter,
  step: step2
}) {
  useEffect(() => {
    onStepEnter && onStepEnter(step2);
  }, []);
  if (!step2.Component) {
    throw new Error(
      `Funnel load error, funnel step should always have a component! Occurred at step: ${step2.name}`
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(step2.Component, {});
}
export {
  FunnelContextProvider as F,
  ReactFunnel as R,
  StaticFunnel as S,
  branch as a,
  buildSteps as b,
  step as c,
  stepTemplate as d,
  Funnel as e,
  group as g,
  jsxRuntimeExports as j,
  split as s,
  useFunnel as u
};
//# sourceMappingURL=react-jhyNFLhw.js.map
